export default __webpack_public_path__ + "static/media/addUser.aac8abed.svg";